import React from 'react';
import { Divider, makeStyles, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { ChannelsPageLayoutHeaderContextType } from 'src/components/Layout/ChannelsPageLayout/channelsPageLayoutTypes';
import { BaseActionsMenu } from 'src/components/Dropdowns';
import BaseTypography from 'src/components/Text/BaseTypography';
import { ChannelsPageLayoutHeaderContext } from 'src/components/Layout/ChannelsPageLayout/channelsLayoutHeaderContext';
import { CreateButton } from 'src/components/UI';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%',
      width: '-webkit-fill-available',
      paddingLeft: theme.spacing(3.5),
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(0),
        display: (props: {
          isSecondarySidebarOpen: boolean;
          channelsListToolbarHidden: boolean;
        }) =>
          props.isSecondarySidebarOpen && !props.channelsListToolbarHidden // hide the channel content toolbar on mobile screen when the secondary sidebar is not mount and channel list toolbar is not hidden
            ? 'none'
            : 'flex',
      },
    },
    noPadding: {
      paddingLeft: theme.spacing(0),
    },
    actionsWrapper: {
      display: 'flex',
      height: '28px',
    },
    divider: {
      margin: theme.spacing(0, 2),
    },
  }),
);
type ChannelContentToolbarProps = Pick<
  ChannelsPageLayoutHeaderContextType,
  'activeChannelTitle' | 'channelHeaderActions'
> & {
  setChannelHeaderMenuAnchorEl: (anchorEl: HTMLElement | null) => void;
  isSecondarySidebarOpen: boolean;
};
export const ChannelContentToolbar: React.FC<ChannelContentToolbarProps> = ({
  activeChannelTitle,
  channelHeaderActions,
  setChannelHeaderMenuAnchorEl,
  isSecondarySidebarOpen, // used to whether hide the channel content toolbar on mobile screen
}) => {
  const { channelsListToolbarHidden, channelNewButtonProps } = React.useContext(
    ChannelsPageLayoutHeaderContext,
  );
  const classes = useStyles({
    isSecondarySidebarOpen,
    channelsListToolbarHidden,
  });

  // this will save the base menu button anchor element
  // to the context so that it can used to anchor other menus.
  // e.g. when clicking on edit members action, it will
  // open the members dropdown menu. That menu will be anchored
  // to the base menu button anchor element.
  const setMenuButtonAnchor = (anchorEl: HTMLElement | null) => {
    setChannelHeaderMenuAnchorEl(anchorEl);
  };

  return (
    <div
      className={classNames(classes.root, {
        [classes.noPadding]: channelsListToolbarHidden,
      })}
    >
      <BaseTypography fontType="13Medium">{activeChannelTitle}</BaseTypography>

      <div className={classes.actionsWrapper}>
        {channelHeaderActions?.length > 0 && (
          <BaseActionsMenu
            actions={channelHeaderActions}
            onActionButtonAnchorElSet={setMenuButtonAnchor}
          />
        )}

        {channelNewButtonProps && (
          <>
            {channelHeaderActions?.length > 0 && (
              <Divider className={classes.divider} orientation="vertical" />
            )}

            <CreateButton
              key="channel-new-file-btn"
              htmlId="channel-new-file-btn"
              {...channelNewButtonProps}
            >
              New
            </CreateButton>
          </>
        )}
      </div>
    </div>
  );
};
